<div class="input-group typeahead typeahead-cliente">
    <ng-template #typeaheadTemplate let-pessoa="item">
        <span>{{pessoa.codigoIntegracaoErp}} - {{pessoa.nome}}</span> 
        <small class="typeahead-cliente-cnpj-cpf">
            {{pessoa.nomeFantasia}} - {{pessoa.cnpjCpf}} - {{pessoa.nomeCidade}} - {{pessoa.uf}}

            <!-- ROTA DE ENTREGA ERP - SCR -->
            <span *ngIf="pessoa.rotaEntregaErpSCR">
                - ROTA DE ENTREGA: {{pessoa.rotaEntregaErpSCR}}
            </span>                  
        </small>        
        <small *ngIf="!isRepresentante" class="typeahead-cliente-cnpj-cpf">{{pessoa.codigoIntegracaoErpRepresentante}} - {{pessoa.nomeRepresentante}}</small>        

        <span *ngIf="!isClienteCadastroCliente(pessoa.cadastroCliente)" class="{{pessoa.cadastroCliente | clienteCadastroBadge}} badge-cadastro">{{pessoa.cadastroCliente | clienteCadastro}}</span>
        <span *ngIf="!isClienteSituacaoAtivo(pessoa.situacaoCliente)" class="{{pessoa.situacaoCliente | clienteSituacaoBadge}} badge-situacao">{{pessoa.situacaoCliente | clienteSituacao}}</span>
    </ng-template>
            
    <div class="input-group-prepend">
        <span class="input-group-text">{{entity?.codigoIntegracaoErp}}</span>
    </div> 
    <input 
        type="text"
        class="form-control"
        #inputTypeahead

        [typeahead]="typeaheadDataSource"
        [typeaheadWaitMs]="300"
        [typeaheadItemTemplate]="typeaheadTemplate"
        typeaheadOptionField="nome"
        [typeaheadMinLength]="2"
        [typeaheadOptionsLimit]="typeaheadOptionsLimit"
        [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
        [ngModel]="typeaheadSelected"
        (ngModelChange)="typeaheadToken = $event"
        (typeaheadOnSelect)="onSelectEntity($event)"
        (typeaheadNoResults)="onChangeTypeaheadNoResults($event)"
        (typeaheadLoading)="isLoading = $event"
        [dropup]="dropup"

        (keyup)="onKeyup($event)"
        (blur)="onBlur()"
        [class.ng-invalid]="ngControl.invalid"
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
        autocomplete="off"
        placeholder="Digite para pesquisar...">

    <span *ngIf="isLoading">
        <i class="fas fa-spinner fa-pulse loading-indicator"></i>
    </span>

    <div class="input-group-append" *ngIf="!disabled">
        <button type="button" class="btn btn-light" (click)="search()" tabindex="-1">
            <i class="fas fa-search" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-light" (click)="clear()" tabindex="-1">
            <i class="fas fa-eraser" aria-hidden="true"></i>
        </button>
    </div>
</div>

<ng-template [ngIf]="entity">
    <sgt-cliente-form-text
        [isShowCadastroSituacao]="true"
        [cadastro]="entity.cadastroCliente"
        [situacao]="entity.situacaoCliente"
        [nomeFantasia]="entity.nomeFantasia"
        [cnpjCpf]="entity.cnpjCpf"
        [nomeCidade]="entity.nomeCidade"
        [uf]="entity.uf"
        [rotaEntregaErpSCR]="entity.rotaEntregaErpSCR">
    </sgt-cliente-form-text>
</ng-template>

<div class="container-cards">
    <!-- Cadastro Incompleto -->
    <div class="card card-warning with-arrow" *ngIf="isExibirCardCadastroIncompleto()">
        <div class="card-arrow"></div>
        <h6 class="card-header card-title">
            <i class="fas fa-exclamation-triangle"></i> Este cliente possui o cadastro incompleto
        </h6>
        <div class="card-body pb-3">
            <p class="card-text">
                {{messageCompletarCadastro}}
            </p>                            
            <button type="button" class="btn btn-link p-0" (click)="editClienteClick()">
                <i class="fas fa-pencil-alt"></i> Completar Cadastro Agora
            </button>
        </div>                       
    </div> 
    <!-- Revisão pendente -->
    <div class="card card-cliente-revisao with-arrow" *ngIf="isExibirCardRevisaoPendente()">
        <div class="card-arrow"></div>
        <h6 class="card-header card-title">
            <i class="far fa-clipboard"></i> Este cliente possui a revisão pendente
        </h6>
        <div class="card-body">
            <p class="card-text mb-0">Acesse o cadastro deste cliente para realizar a sua revisão</p>                            
        </div>                       
    </div> 

   <!-- Mensagem Carta de Isenção IPI Vencida -->
   <sgt-card-message-carta-isencao-ipi-vencida
        *ngIf="isShowCardCartaIsencaoIpiVencida()"
        [cartaIsencaoIpiVencida]="entity?.cartaIsencaoIpiVencidaCliente">
    </sgt-card-message-carta-isencao-ipi-vencida>
    <!-- Mensagem Destaque IPI -->
    <sgt-card-message-destaque-ipi
        *ngIf="isShowCardDestaqueIpi()"
        [isentoIpi]="entity?.isentoIpiCliente">
    </sgt-card-message-destaque-ipi>    
</div>


<p class="form-text text-muted" *ngIf="typeaheadNoResults === true">Nenhum cliente foi encontrado</p>

<!-- Modal de pesquisa -->
<sgt-cliente-filter-modal
    idModal="clienteFilterModal"

    [somenteClientesEmCarteira]="somenteClientesEmCarteira"
    [somenteClientesEmCarteiraAtiva]="somenteClientesEmCarteiraAtiva"
    [somenteClientesEmCarteiraInativa]="somenteClientesEmCarteiraInativa"
    [somenteClientes]="somenteClientes"
    [somenteClientesProspects]="somenteClientesProspects"
    [somenteClientesCongelados]="somenteClientesCongelados"
    [somenteClientesBloqueados]="somenteClientesBloqueados"
    [somenteClientesBaixados]="somenteClientesBaixados"
    [somenteClientesOutros]="somenteClientesOutros"
    [cadastroProspect]="cadastroProspect"
    [cadastroCliente]="cadastroCliente"
    [cadastroBaixado]="cadastroBaixado"
    [cadastroOutros]="cadastroOutros"

    [somenteClientesAtivos]="somenteClientesAtivos"
    [somenteClientesInativos]="somenteClientesInativos"
    [situacaoNovo]="situacaoNovo"
    [situacaoPositivo]="situacaoPositivo"
    [situacaoAtivo]="situacaoAtivo"
    [situacaoPreInativo]="situacaoPreInativo"
    [situacaoInativo]="situacaoInativo"
    [situacaoCongelado]="situacaoCongelado"
    [situacaoBloqueado]="situacaoBloqueado"
    [situacaoPreBaixado]="situacaoPreBaixado"
    [situacaoBaixado]="situacaoBaixado"
    [situacaoOutros]="situacaoOutros"

    [somenteCentralDeCompraV1]="somenteCentralDeCompraV1"
    [somenteCentralDeCompra]="somenteCentralDeCompra"
    [idClienteAtual]="idClienteAtual"

    (selectEntity)="onSelectEntityModal($event)"
    #clienteFilterModal>
</sgt-cliente-filter-modal>


<!-- Modal para selecionar um participante de uma central de compras -->
<sgt-cliente-central-compra-select-participante-modal
    #clienteCentralCompraSelectParticipanteModal
    [subtitle]="subTitleSelectParticipanteCentralComprasModal"
    (onSelectParticipante)="onSelectParticipanteCentralCompras($event)"
    (onCancelSelectParticipante)="onCancelSelectParticipanteCentralCompras()">
</sgt-cliente-central-compra-select-participante-modal>